import CreditCard from './CreditCard.view';

export default CreditCard;
